import React from 'react';
import FieldsImage from '../Images/FieldsImage.png'
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import { BasicViewer } from '../Modules/Viewer/BasicViewer';
import { getDataByGas } from '../Functions/APIservice/gasAPI';
import { GetDicomUrls } from '../Functions/APIservice/useStorage';
import { useAuthContext } from '../Modules/Auth/AuthContext';
import mnistMemImg from '../Images/IMG_MNiST_Member.jpeg';
import LoadingHome from '../Figma/LoadingHome/LandingHome';
import LoadedHome from './Home/LoadedHome';

//import "./styles/Home.css";

export function Home(): JSX.Element {
    const [informationPosts,setInformationPosts] = React.useState<{info:string,date:string}[]>([]);
    //const [headMri,setHeadMri]= React.useState<string[]>([]);
    const [showViewer,setShowViewer] = React.useState<boolean>(true);

    const { userData } = useAuthContext();

    const handleOpenLink = (url:string) => {
        const toUrl = url
        window.location.href = toUrl;
    }

    const DummyViewerStyle: React.CSSProperties = {
        color:'black',
        width:"100%",
        height:"40vh",
      };

    React.useEffect(()=>{
        getDataByGas(
            {mode:'UpdateInformation'}
            )
        .then((response:Response) => {
            response.json().then((docx:{info:string,date:string}[]) => {
                setInformationPosts(docx)
            }).catch((error:string) => {
                console.error("Error:", error);
            });
        })
    },[informationPosts])

    /*
    React.useEffect(()=>{
        let abortController = new AbortController(); 
        GetDicomUrls('Basic/Head/Head_MRI/501', 501, 1, 25)
        .then((result:string[])=>{
            setHeadMri(result);
            setShowViewer(true);
        })
        return () => {  
            abortController.abort();  
            } 
        },[])
    */

    return (
        <div>
            <Grid>
                {userData?.userStatus === 'ban' ? 
                    <Alert severity="error">
                        このアカウントは現在停止されています。他ページの閲覧はできません。
                    </Alert>:
                    <div></div>
                }              
            </Grid>
            <div>
                {
                userData? 
                <LoadedHome></LoadedHome>:
                <LoadingHome></LoadingHome>                
                }
            </div>
            {/*
            <Container maxWidth="lg">
                
                <Grid>
                    <Card sx={{ maxWidth: '100%' }}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                height="300"
                                image={FieldsImage}
                                alt="green iguana"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 3, gap: 5, }} >
                    <Typography variant="h6" sx={{ ml: 3 }}>
                        Mstaとは
                    </Typography>
                    <Grid container alignItems="start" justifyItems="center"
                        sx={{
                            ml: 3,
                            display: 'grid',
                            gridTemplateColumns: { md: '1fr 1fr' },
                            gap: 3,
                        }}>      
                        <Grid xs={11}>
                            <Card
                                sx={{
                                    height: 350,
                                }}>
                                <CardContent>
                                    <Typography variant="h6" component="div" >
                                    使いやすいツールを目指して
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 3 }}>
                                    このツールは,放射線診断科医、医学生、情報科の学生によって作られたものです。医学生が欲しいものを形にしたので、効率よく勉強できる形になっています。解説はプロの放射線診断科医が作成しています。このツールを通して、普段放射線診断医がどのように鑑別を行っているか垣間見ることができるでしょう。今こそ自分のスキルアップをしてみませんか？
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small"
                                        onClick={() => handleOpenLink('basic')}>
                                        Basic</Button>   
                                </CardActions>
                                <CardActions>
                                公式サポートページは
                                <Button size="medium"
                                        onClick={() => {window.open('https://sites.google.com/mnes.org/msta-support/%E3%83%9B%E3%83%BC%E3%83%A0', '_blank')}}>
                                        こちら</Button>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid xs={11}
                        width={{md:400}}
                        height={{md:400,xs:300}}
                           >
                            <Typography variant="h6" component="div" >
                                viewer
                            </Typography>
                            <Grid
                                sx={{
                                    height: '100vh',
                                }}>
                                {showViewer?
                                <BasicViewer
                                    imageIds={WomanHeadT2wJpg}
                                    width="100%"
                                    height="40vh"
                                />:
                                <div style={DummyViewerStyle}></div>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container alignItems="center" justifyItems="center" sx={{ mt: 3 }}>
                    <Card 
                        sx={{
                            minWidth: "90%",
                            ml: 3,
                            mr: 1,
                        }}>
                        <CardContent >
                            <Typography variant="h6" component="div" >
                                情報更新
                            </Typography>
                            <div >
                                {informationPosts.map((post) => {
                                    return (
                                        <Grid sx={{
                                            mt: 1,
                                            display: 'grid',
                                            textAlign: "center",
                                            gridTemplateColumns: { md: '1fr 1fr' },
                                            gap: 1,
                                        }}>
                                            <Typography variant="body1" sx={{ mt: 3 }}>
                                                {post.date}
                                            </Typography>
                                            <Typography variant="body1" sx={{ mt: 3 }}>
                                                {post.info}
                                            </Typography>
                                        </Grid>
                                    )
                                })}
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 3, mb: 3, gap: 5, }}>
                    <Typography variant="h6" sx={{ ml: 3 }}>
                        MNiSTとは
                    </Typography>
                    <Grid
                        container
                        sx={{
                            mt: 3,
                            minWidth: "90%",
                            ml: 3,
                            mr: 3,
                            display: 'grid',
                            gridTemplateColumns: { md: '1fr 1fr' },
                            gap: 6,
                        }}>
                        <Grid>
                            <Typography variant="h5" sx={{ mt: 3 }}>
                                「学生の目線から医療、そして世界をより良いものにしたい」
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 3 }}>
                                上記の理念に基づいて、学生ながらに様々な活動を自身で考え、実行している学生団体です。2020年12月設立🚩株式会社エムネスご後援の元、活動しています👨‍⚕️👩‍⚕️医療支援システムLOOKRECを用いた勉強会や、様々な業種の講師による講演会等を主催しております！
                            </Typography>
                        </Grid>
                        <Grid >
                            <Card sx={{ maxWidth: '100%' }}>
                                <CardActionArea>
                                    <CardMedia
                                        component="img"
                                        height="350"
                                        image={mnistMemImg}
                                        alt="green iguana"
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
                    */}
        </div>
    )
}
